/* eslint-disable jsx-a11y/heading-has-content */
import { ComponentProps } from 'react'

import { joinStyles } from '@/utils/app/theme'

import { ColorHeading, VariantHeading } from '@/types/ui/heading'
import * as styles from './index.css'

type HeadingProperties = ComponentProps<'h1'> & {
    variant?: VariantHeading
    color?: ColorHeading
    center?: boolean
}

export const Heading = ({
    className,
    variant = 'h1',
    color = 'primary',
    center,
    ...properties
}: Readonly<HeadingProperties>) => {
    return (
        <>
            {/* H1 */}
            {variant === VariantHeading.enum.h1 && (
                <h1
                    className={joinStyles(
                        styles.root,
                        styles[variant],
                        styles[color],
                        center && styles.center,
                        className,
                    )}
                    {...properties}
                />
            )}

            {/* H2 */}
            {variant === VariantHeading.enum.h2 && (
                <h2
                    className={joinStyles(
                        styles.root,
                        styles[variant],
                        styles[color],
                        center && styles.center,
                        className,
                    )}
                    {...properties}
                />
            )}

            {/* H3 */}
            {variant === VariantHeading.enum.h3 && (
                <h3
                    className={joinStyles(
                        styles.root,
                        styles[variant],
                        styles[color],
                        center && styles.center,
                        className,
                    )}
                    {...properties}
                />
            )}
        </>
    )
}
